import styled from "@emotion/styled";
import { Box, Grid, Typography } from "@mui/material";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { Button } from "../../components/Button";
import { IJobBenchmarking } from "../../interfaces/Job";
import { useLocale } from "../../providers/LocaleProvider";
import AddIcon from "../../resources/images/icons-add.svg";
import CheckIcon from "../../resources/images/icons-check.svg";
import { KLAYO_COLORS } from "../../themes";
import { JobBenchMarkingType } from "../../utilities/validationSchema";

export type JobDescriptionResultTabProps = {
  results?: IJobBenchmarking;
};

const JobDescriptionResultTab = ({ results }: JobDescriptionResultTabProps) => {
  const { setValue, watch } = useFormContext<JobBenchMarkingType>();
  const { translate } = useLocale();

  const yourJobDescription = watch("jobDescription");

  const organizationJobDescription = useMemo(
    () => results?.organizationJobDefinition?.description || "",
    [results]
  );
  const standardJobDescription = useMemo(
    () => results?.standardLibraryJobDefinition?.description || "",
    [results]
  );

  const onToggleTakeJobDescription = () => {
    setValue("jobDescription", yourJobDescription ? undefined : standardJobDescription, {
      shouldDirty: true,
      shouldTouch: true
    });
  };

  return (
    <Grid container spacing={8}>
      <Grid item xs={6}>
        <Box display={"flex"} flexDirection={"column"} gap={2}>
          <Typography fontWeight={500} color={KLAYO_COLORS.GreyGR500} variant='caption'>
            {translate("settingsViews.jobBenchmarking.yourJob").toUpperCase()}
          </Typography>
          <StyledJobDescription
            style={{
              fontSize: "1rem"
            }}
            dangerouslySetInnerHTML={{
              __html: yourJobDescription || organizationJobDescription
            }}
          />
        </Box>
      </Grid>
      <Grid item xs={6}>
        <Box display={"flex"} flexDirection={"column"} gap={2}>
          <Typography fontWeight={500} color={KLAYO_COLORS.GreyGR500} variant='caption'>
            {translate("settingsViews.jobBenchmarking.klayoIntelligenceJob").toUpperCase()}
          </Typography>
          <StyledJobDescription
            style={{
              fontSize: "1rem"
            }}
            dangerouslySetInnerHTML={{
              __html: standardJobDescription
            }}
          />
          {organizationJobDescription !== standardJobDescription && !!standardJobDescription && (
            <Button
              label={
                yourJobDescription
                  ? translate("settingsViews.jobBenchmarking.dontTakeJobDescription")
                  : translate("settingsViews.jobBenchmarking.takeJobDescription")
              }
              variant='outlined'
              size='md'
              startIcon={yourJobDescription ? <CheckIcon /> : <AddIcon />}
              sx={{
                width: "min-content"
              }}
              onClick={onToggleTakeJobDescription}
              type='button'
            />
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

const StyledJobDescription = styled("div")(() => ({
  "& p": {
    margin: 0
  }
}));

export default JobDescriptionResultTab;
